
























































































































































































































































































import {Component, Mixins, Watch} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {$} from '@/facade'
import NavbarDropdown from '@/components/navbar/NavbarDropdown.vue'
import NavbarDropdownItem from '@/components/navbar/NavbarDropdownItem.vue'
import SessionButton from '@/components/SessionButton.vue'
import NavbarWalletSession from '@/components/navbar/NavbarWalletSession.vue'

enum State {
  NORMAL,
  SIDEBAR_OPEN,
}

@Component({
  components: {
    NavbarWalletSession,
    NavbarDropdownItem,
    NavbarDropdown,
    SessionButton,
  },
})
export default class Navbar extends Mixins(MixinScreenSize) {
  State = State
  state = State.NORMAL

  @Watch('state')
  onStateChange(newState: State) {
    if (newState === State.SIDEBAR_OPEN) {
      document.documentElement.style.overflow = 'hidden'
      document.body.style.overflow = 'hidden'
      return
    }

    document.documentElement.style.overflow = ''
    document.body.style.overflow = ''
  }

  isStateIn(...states: number[]) {
    return states.includes(this.state)
  }

  goToState(state: State) {
    this.state = this.state === state ? State.NORMAL : state
  }

  resetState() {
    this.state = State.NORMAL
  }

  classLink(...names: string[]) {
    return {
      'navbar__link--active': names.includes(this.$route.name as string),
    }
  }
}
